import { getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { AddFrameCommand } from './AddFrameCommand';
import { CommandFunction } from './Command';
import { getOverlayColor } from 'state/actions';
import { SoundWaveFrameData } from 'data/FlyerData';
import { FrameType } from 'data/FrameType';
import { SoundWaveType } from '@beatflyer/shaders-lib';
import { SoundWaveFrame } from 'data/SoundWaveFrame';

export class AddSoundWaveFrameCommand extends AddFrameCommand {
  type: SoundWaveType;
  constructor(layerId: string | undefined, type: SoundWaveType) {
    super(layerId);
    this.type = type;
  }
  execute(firstTime?: boolean): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { app, flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const { resolution } = flyer;
      let color = getOverlayColor(resolution, layer);
      if (Array.isArray(color) && color.length > 1) {
        color = color[0];
      }
      const frame = new SoundWaveFrame(resolution.width, resolution.height);
      const data: SoundWaveFrameData = {
        type: FrameType.SoundWave,
        waveType: this.type,
        box: {
          x: 0,
          y: 0,
          width: resolution.width,
          height: resolution.height
        },
        effectProperties: {
          props: {
            color
          }
        }
      };
      frame.populateWithData(data);
      await frame.load();
      frame.hasBeenEdited = false;
      this.dispatchWithFrame(
        dispatch,
        frame,
        layer,
        app.openedModals.length > 0,
        firstTime
      );
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/AddSoundWaveFrameCommand.ts